import "./QualityCheckList.scss"
import { useNavigate } from "react-router-dom"
import { Column, FilterRow, HeaderFilter } from "devextreme-react/data-grid"
import { t } from "i18next"
import { PagedList } from "../../../../core/api/pagedList"
import { useScreenSize } from "../../../../core/hook/useScreenSize"
import QualityCheckApi from "../../api/qualityCheckApi"
import { QualityCheckDto } from "../../model/qualityCheckDtos"
import { DateOnly, GenericDataGrid, IconButtonEdit, IconButtonSummary, Row } from "../../../../core/components"

export default function QualityChecksList() {
    const navigate = useNavigate()
    const { isXSmall } = useScreenSize()

    const getTwoWeeksAgoDate = (): Date => {
        const today = new Date()
        const twoWeeksAgo = new Date(today.getTime() - 60 * 24 * 60 * 60 * 1000)
        return twoWeeksAgo
    }

    const handleRowClick = (id: string) => {
        navigate(`/qualitychecks/${id}`)
    }

    const goToSummary = (id: string) => {
        navigate(`/qualitychecks/${id}/summary`)
    }

    const fetchData = async (odataQueryParameters?: string): Promise<PagedList<QualityCheckDto>> => {
        return await QualityCheckApi.getQualityChecks(odataQueryParameters)
    }

    const stateFilterOptions = [
        { text: t("Scheduled"), value: 1 },
        { text: t("Active"), value: 2 },
        { text: t("Finished"), value: 4 },
        { text: t("Expired"), value: 8 },
    ]

    const qualityCheckStates = [
        { text: t("Scheduled"), value: 0 },
        { text: t("Active"), value: 1 },
        { text: t("Finished"), value: 2 },
        { text: t("Expired"), value: 3 },
    ]

    const stateLookup = {
        dataSource: {
            store: {
                type: 'array',
                data: qualityCheckStates,
                key: 'id'
            },
        },
        valueExpr: "value",
        displayExpr: "text",
    }

    return (
        <GenericDataGrid
            id="QualityChecksList"
            className="card m-05 quality-checks-list-height"
            rowKey={"idQualityCheck"}
            fetchData={fetchData}
            handleEdit={handleRowClick}
            occupiedHeight={170}
            columnHidingEnabled={false}>
            <FilterRow visible applyFilter="onClick" />
            <HeaderFilter visible />
            <Column
                dataField="checklist.name"
                dataType="string"
                caption={t("Checklist Name")}
                width={isXSmall ? 100 : 300}
                allowHeaderFiltering={false}
                allowSorting={false}
                allowFiltering={false} />
            <Column
                dataField="scheduledOn"
                dataType="date"
                minWidth={230}
                caption={t("Scheduled On")}
                selectedFilterOperation="between"
                filterOperations={["between"]}
                defaultFilterValue={[getTwoWeeksAgoDate(), new Date()]}
                allowHeaderFiltering={false}
                cellRender={data => <DateOnly dateUtc={data.data.scheduledOn} />} />
            <Column
                dataField="state"
                dataType="string"
                caption={t("State")}
                width={170}
                lookup={stateLookup}
                allowHeaderFiltering
                allowFiltering={false}>
                <HeaderFilter search={{ enabled: true }} allowSelectAll dataSource={stateFilterOptions} />
                <FilterRow applyFilter="auto" />
            </Column>
            <Column
                dataField="inspectorName"
                dataType="string"
                caption={t("Inspector Name")}
                minWidth={200}
                allowHeaderFiltering={false}
                allowFiltering={false} />
            <Column
                fixed
                caption={t("Actions")}
                width={100}
                fixedPosition="right"
                cellRender={(cellInfo) => (
                    <Row>
                        <IconButtonSummary
                            size="small"
                            tooltip={t("Summary")}
                            onClick={() => goToSummary(cellInfo.data.idQualityCheck)} />
                        <IconButtonEdit
                            size="small"
                            tooltip={t("Details")}
                            onClick={() => {handleRowClick(cellInfo.data.idQualityCheck)}} />
                    </Row>
                )} />
        </GenericDataGrid>
    )
}
